import axios from 'axios'
import Future from 'fluture'
import {assoc, prop} from 'ramda'
import {fetchUrlBasedOnEnv} from './util/helpers'
import {getSessionKey, TOKEN_KEY} from './util/storage'

/*
 Added CORS proxy for fetching company report of a non home country
 */
export default () => {
  const homeCountries = ['BE', 'DE', 'DK', 'NL', 'FR', 'IE', 'GB', 'US', 'NO', 'SE', 'JP']
  // added the proxy url for bypassing CORS issue
  const proxyUrl = 'https://cors-anywhere.herokuapp.com/'

  const getBaseUrl = (env) => `${fetchUrlBasedOnEnv(env)}`

  const getCompleteUrl = (urlPath, env) => `${getBaseUrl(env)}/${urlPath}`

  const getF = Future.encaseP2(axios.get)
  const postF = Future.encaseP3(axios.post)

  const isCORSProxyNeeded = (ggsId = '') => {
    let countryCode = ggsId.substring(0, 2)
    return homeCountries.indexOf(countryCode) === -1
  }

  const getHeaderConfig = () => {
    return {
      'headers': {
        'Authorization': getSessionKey(TOKEN_KEY),
      },
    }
  }
  const addRequestUrlToResponse = (reqUrl, reqTime) => (data) => reqTime ? assoc('responseTime', (((new Date()).getTime() - reqTime) / 1000), assoc('requestUrl', reqUrl, data)) : assoc('requestUrl', reqUrl, data)

  const get = (url, ggsId) => {
    let completeUrl = getCompleteUrl(url)
    // add CORS proxy only if the country is not a home country
    if (ggsId && isCORSProxyNeeded(ggsId)) {
      completeUrl = `${proxyUrl}${completeUrl}`
    }
    let reqTime = (new Date()).getTime()
    return getF(completeUrl, getHeaderConfig())
      .bimap(prop('response'), prop('data'))
      .bimap(addRequestUrlToResponse(completeUrl, reqTime), addRequestUrlToResponse(completeUrl, reqTime))
  }

  const post = (url) => (data, config, env) => {
    let completeUrl = getCompleteUrl(url, env)
    return postF(completeUrl, data, config)
      .bimap(prop('response'), prop('data'))
      .bimap(addRequestUrlToResponse(completeUrl), addRequestUrlToResponse(completeUrl))
  }

  return {
    authenticateUser: post('authenticate'),
    searchCompanies: (params) => get(`companies?${params}`),
    getCompanyReport: (ggsId) => get(`companies/${ggsId}?language=en`, ggsId),
    getSearchCriteria: (countryList) => get(`companies/searchcriteria?countries=${countryList}`),
    getAccessCountries: () => get('access/countries'),
  }
}



// WEBPACK FOOTER //
// ./src/api.js